/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mobile_Download_Waiting_For_WifiInputs */

const en_mobile_download_waiting_for_wifi = /** @type {(inputs: Mobile_Download_Waiting_For_WifiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Waiting for Wi-Fi`)
};

const es_mobile_download_waiting_for_wifi = /** @type {(inputs: Mobile_Download_Waiting_For_WifiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esperando Wi-Fi`)
};

/**
* | output |
* | --- |
* | "Waiting for Wi-Fi" |
*
* @param {Mobile_Download_Waiting_For_WifiInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mobile_download_waiting_for_wifi = /** @type {((inputs?: Mobile_Download_Waiting_For_WifiInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mobile_Download_Waiting_For_WifiInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mobile_download_waiting_for_wifi(inputs)
	return en_mobile_download_waiting_for_wifi(inputs)
});